import { ObservationSettings } from './types';
import { ImageriesDisplayOption } from '../../constants';

export const DEFAULT_OBSERVATION_SETTINGS: ObservationSettings = {
  calendar: false,
  imagingOnly: false,
  labels: true,
  imageriesDisplay: ImageriesDisplayOption.Custom,
};
